var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { toggleSprinklerSampleStatus } from '../services/SprinklerSamplingService';
import { sprinklerSamplingKeys } from './queryKeys';
import { NAMESPACE, SUBMISSION_STATUS } from '../constants';
export function useToggleStatusMutation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (_a) => __awaiter(this, [_a], void 0, function* ({ submissionId }) {
            var _b;
            const response = yield toggleSprinklerSampleStatus(submissionId);
            if (response.error) {
                throw new Error(((_b = response.error.errors) === null || _b === void 0 ? void 0 : _b.join(', ')) || response.error.message);
            }
            return response.data;
        }),
        onSuccess: (data) => {
            const statusMessage = data.status === SUBMISSION_STATUS.COMPLETED
                ? translate('status.marked_complete', { namespace: NAMESPACE })
                : translate('status.marked_sent', { namespace: NAMESPACE });
            toast.success(statusMessage);
            void queryClient.invalidateQueries({
                queryKey: sprinklerSamplingKeys.all
            });
        },
        onError: (error) => {
            toast.error(error.message || translate('status.error', { namespace: NAMESPACE }));
        }
    });
}
